<template>
  <div
    class="list-entry"
    :class="{ voted: userHasVoted }"
    @click="$emit('questionClicked', question.questionId)"
  >
    <span>{{ question.texts[lang] }}</span>
  </div>
</template>

<script>
import { getImage } from '@/services/StyleService';
import { mapGetters } from 'vuex';

export default {
  name: 'question-list-entry',
  props: {
    question: Object,
    userHasVoted: Boolean
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
    checkIcon() {
      return getImage('./checkmark.svg');
    },
    closeIcon() {
      return getImage('./close.svg');
    }
  }
};
</script>

<style lang="scss" scoped>
.question-is-good {
  width: 24px;
}
.voted {
  color: #989a9d;
  text-decoration: line-through;
}
.icon {
  width: 25px;
}
</style>
